var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "4 2 8 6 0 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    points: "4 10 8 14 0 14",
    transform: "matrix(1 0 0 -1 0 24)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortNone);
export default __webpack_public_path__ + "static/media/sort-none.ead9b6b4afea031a9dd25b9fd69e50c1.svg";
export { ForwardRef as ReactComponent };